<div [formGroup]="formGroup" fxLayoutAlign="start center" class="table-form-field" fxLayoutGap="0.5rem">
    <ng-container [ngSwitch]="input.get('type').value">
  
      <!-- Input -->
      <mat-form-field *ngSwitchCase="'input'" class="input-space">
        <mat-label>{{ input.get('label').value }}</mat-label>
        <input matInput [placeholder]="input.get('placeholder').value" formControlName="value"
          [readonly]="input.get('readOnly').value">
      </mat-form-field>
  
      <!-- Dropdown -->
      <mat-form-field *ngSwitchCase="'dropdown'" class="input-space">
        <mat-label>{{ input.get('label').value }}</mat-label>
        <mat-select formControlName="value" [multiple]="input.get('multiple').value" [disabled]="input.get('readOnly').value">
          <mat-option *ngFor="let option of input.get('options').value" [value]="option.value || option">
            {{ option.label || option }}
          </mat-option>
        </mat-select>
      </mat-form-field>
  
      <!-- Checkbox -->
      <mat-checkbox *ngSwitchCase="'checkbox'" formControlName="value" [disabled]="input.get('readOnly').value">
        {{ input.get('label').value }}
      </mat-checkbox>
  
      <!-- Textarea -->
      <mat-form-field *ngSwitchCase="'textarea'" class="input-space">
        <mat-label>{{ input.get('label').value }}</mat-label>
        <textarea matInput [placeholder]="input.get('placeholder').value" formControlName="value" rows="3"
          [readonly]="input.get('readOnly').value"></textarea>
      </mat-form-field>
  
      <!-- Radio -->
      <div *ngSwitchCase="'radio'">
        <label>{{ input.get('label').value }}</label>
        <mat-radio-group formControlName="value" [disabled]="input.get('readOnly').value">
          <mat-radio-button *ngFor="let option of input.get('options').value" [value]="option.value || option">
            {{ option.value.label }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
  
    </ng-container>
  </div>